<!-- 参观日期 -->
<template>
  <div class="page">
    <div class="date">
      <div
        v-for="(item, index) in canBookTime.length >= 7
          ? canBookTime.slice(0, 7)
          : canBookTime"
        :class="['date-item', current == index ? 'date-item-current' : '']"
        :key="index"
        @click="selectDate(item, index)"
      >
        <p>{{ item }}</p>
        <p>{{ formatDay(item) }}</p>
      </div>
    </div>
    <div class="sence" v-if="shape.length > 0">
      <p>入馆时间:</p>
      <div>
        <p
          v-for="(item, index) in shape"
          :key="index"
          :class="[currentSence === index ? 'sence-current' : '']"
          @click="selectSence(index, item)"
        >
          <span>{{ item.title }}</span>
          <span>{{ item.type }}</span>
        </p>
      </div>
    </div>
    <div class="sence" v-if="shape.length > 0">
      <p>剩余门票:</p>
      <!-- <p>{{ left }}张</p> -->
      <p>{{ left >= 0 ? left : 0 }}张</p>
    </div>
    <div style="padding-top:30px">
      <a-button @click="leftStep" style="margin-right:15px">上一步</a-button>
      <a-button type="primary" @click="nextStep">
        下一步
      </a-button>
    </div>
  </div>
</template>

<script>
import {
  getTicketDetail,
  getTicketsType,
  getTicketDetailSeats
} from "@/api/api-ticket";
import moment from "moment";
import { Modal } from "ant-design-vue";
moment.locale("zh-cn");
export default {
  components: {},
  data() {
    return {
      canBookTime: [],
      shape: [],
      current: 0, //日期
      currentSence: -1, //场次
      date: "",
      senceId: "",
      sence: {},
      left: 0
    };
  },
  computed: {
    tid() {
      return sessionStorage.getItem("tid");
    }
  },
  watch: {},
  methods: {
    async getDetail() {
      const { can_book_time, shape } = await getTicketDetail({ id: this.tid });
      this.canBookTime = can_book_time;
      sessionStorage.setItem("shape", JSON.stringify(shape));
    },
    selectDate(item, index) {
      this.current = index;
      this.currentSence = -1;
      this.left = 0;
      this.getSence(this.tid, item);
    },
    async selectSence(index, item) {
      this.currentSence = index;
      this.sence = item;
      sessionStorage.setItem("sence", JSON.stringify(item));
      this.senceId = item.id;
      const { left } = await getTicketDetailSeats({
        id: this.tid,
        date: this.date,
        ticket_type: this.senceId
      });
      console.log(left);
      this.left = left;
    },
    // 传入时间获取今天是周几
    formatDay(date) {
      return moment(date).format("dddd");
    },
    // 获取场次
    async getSence(id, date) {
      this.date = date;
      sessionStorage.setItem("date", date);
      const shape = await getTicketsType({ id: id, date: date });
      this.shape = shape;
    },
    // 点击下一步按钮
    nextStep() {
      let that = this;
      if (this.currentSence == -1) {
        this.$message.warning("请选择入馆时间");
      } else if (this.left && this.left > 0) {
        // 下一步
        if (sessionStorage.getItem("open_health_notice") == 1) {
          Modal.confirm({
            title: "健康管理承诺书",
            content: sessionStorage.getItem("health_notice"),
            centered: true,
            okText: "同意",
            cancelText: "不同意",
            onOk() {
              that.$emit("selectDate", "next");
            }
          });
        } else {
          that.$emit("selectDate", "next");
        }
      } else {
        this.$message.warning("门票已售空");
      }
    },
    leftStep() {
      this.$emit("selectDate", "left");
    }
  },
  async created() {
    await this.getDetail();
    await this.getSence(this.tid, this.canBookTime[0]);
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.page {
  width: 100%;
  height: 500px;
  overflow-y: scroll;
  padding: 30px 100px 10px 100px;
}
.date {
  display: flex;
  justify-content: space-between;
}
.date-item {
  width: 120px;
  height: 120px;
  border: 1px solid #ccc;
  padding-top: 20px;
  cursor: pointer;
  transition: all 0.3s;
  // background-color: #e9e9e9;
  p {
    font-weight: 700;
  }
  &:hover {
    background-color: #e6f7ff;
    p {
      color: #1890ff;
    }
  }
}
.date-item-current {
  background-color: #e6f7ff;
  p {
    color: #1890ff;
  }
}
.sence {
  margin-top: 40px;
  display: flex;
  align-items: center;
  & > p {
    font-weight: 700;
    font-size: 16px;
    margin-right: 20px;
  }
  & > div {
    width: 80%;
    display: flex;
    // justify-content: space-between;
    p {
      cursor: pointer;
      padding: 10px;
      border: 1px solid #ccc;
      margin-right: 12px;
    }
  }
}
.sence-current {
  background-color: #e6f7ff;
  color: #1890ff;
}
</style>
